import React, { useState, useEffect } from 'react';
import { obterListaCompleta50Cromos } from './cadernetaConfig';
import { onSnapshot, collection } from 'firebase/firestore';

function CadernetaGaleria({ db, auth, aoSair }) {
  const [cromosCaderneta, setCromosCaderneta] = useState([]);
  const [cromosDesbloqueadosIds, setCromosDesbloqueadosIds] = useState([]);
  const meuId = auth.currentUser?.uid;

  // DICIONÁRIO MULTILÍNGUE BLINDADO VIA .SUBSTRING(0, 2)
  const idiomaNativo = (navigator.language || "pt").substring(0, 2).toLowerCase();
  
  const tC = {
    pt: { titulo: "CADERNETA DE STICKERS 🏟️", colecao: "COLEÇÃO:", completos: "COMPLETOS", adquirido: "✓ ADQUIRIDO" },
    en: { titulo: "STICKER ALBUM 🏟️", colecao: "COLLECTION:", completos: "COMPLETED", adquirido: "✓ OWNED" },
    es: { titulo: "ÁLBUM DE CROMOS 🏟️", colecao: "COLECCIÓN:", completos: "COMPLETOS", adquirido: "✓ ADQUIRIDO" },
    fr: { titulo: "ALBUM D'AUTOCOLLANTS 🏟️", colecao: "COLLECTION :", completos: "COMPLÉTÉS", adquirido: "✓ ACQUIS" }
  }[idiomaNativo] || { titulo: "STICKER ALBUM 🏟️", colecao: "COLLECTION:", completos: "COMPLETED", adquirido: "✓ OWNED" };

  useEffect(() => {
    setCromosCaderneta(obterListaCompleta50Cromos());
  }, []);

  useEffect(() => {
    if (!meuId || !db) return;

    // Conexão direta à subcoleção universal legítima
    const userCadernetaRef = collection(db, "utilizadores", meuId, "caderneta_stickers");
    
    const unsubscribe = onSnapshot(userCadernetaRef, (snapshot) => {
      const desbloqueados = snapshot.docs.map(doc => String(doc.id));
      setCromosDesbloqueadosIds(desbloqueados);
    }, (error) => {
      console.error("Erro ao escutar caderneta global:", error);
    });

    return () => unsubscribe();
  }, [meuId, db]);

  // CORREÇÃO CIRÚRGICA: Filtra os objetos e extrai apenas o COMPRIMENTO NUMÉRICO (.length)
  const totalConcluidoNumero = cromosCaderneta.filter(c => 
    cromosDesbloqueadosIds.includes(String(c.cromoNumero))
  ).length;

  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: '#050505', zIndex: 9999,
      display: 'flex', flexDirection: 'column', fontFamily: 'sans-serif', overflow: 'hidden'
    }}>
      <div style={{
        padding: '20px', borderBottom: '2px solid #39FF14', display: 'flex',
        justifyContent: 'space-between', alignItems: 'center', background: 'rgba(0,0,0,0.8)'
      }}>
        <div>
          <h2 style={{ color: '#FFF', margin: 0, fontSize: '18px', fontWeight: '900' }}>
            {tC.titulo}
          </h2>
          <small style={{ color: '#39FF14', fontWeight: 'bold' }}>
            {/* INJEÇÃO DO VALOR TOTAL CORRIGIDA DE FORMA ATÓMICA */}
            🏆 {tC.colecao} {totalConcluidoNumero} / 50 {tC.completos}
          </small>
        </div>
        <button 
          onClick={aoSair}
          style={{
            background: '#FF3131', color: '#FFF', border: 'none', borderRadius: '50%',
            width: '32px', height: '32px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 0 10px #FF3131',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
        >
          ✕
        </button>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '15px', boxSizing: 'border-box' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', paddingBottom: '30px' }}>
          {cromosCaderneta.map((cromo) => {
            const estaGanho = cromosDesbloqueadosIds.includes(String(cromo.cromoNumero));
            return (
              <div 
                key={cromo.id}
                style={{
                  backgroundColor: '#111', border: estaGanho ? '2px solid #39FF14' : '1px solid #222',
                  borderRadius: '12px', padding: '10px 6px', textAlign: 'center', position: 'relative',
                  boxShadow: estaGanho ? '0 0 10px rgba(57,255,20,0.35)' : 'none',
                  opacity: cromo.emBreve ? 0.4 : 1
                }}
              >
                <span style={{ position: 'absolute', top: '4px', left: '6px', color: estaGanho ? '#39FF14' : '#666', fontSize: '9px', fontWeight: '900' }}>
                  #{cromo.cromoNumero}
                </span>
                <img 
                  src={cromo.icone} 
                  alt={cromo.nome}
                  style={{
                    width: '50px', height: '50px', objectFit: 'contain', margin: '8px auto 4px auto', display: 'block',
                    filter: estaGanho ? 'none' : 'grayscale(100%) opacity(35%)'
                  }}
                />
                <span style={{ color: estaGanho ? '#FFF' : '#444', fontSize: '10px', fontWeight: 'bold', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>
                  {cromo.nome}
                </span>
                <span style={{ color: estaGanho ? '#39FF14' : '#888', fontSize: '9px', fontWeight: '900', display: 'block', marginTop: '4px' }}>
                  {estaGanho ? tC.adquirido : `⚽ ${cromo.preco}`}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default CadernetaGaleria;
